import { Fragment } from 'react';

import { SEARCH_SPLIT_REGEX } from '~/chords/Select/components/DropdownTreeSingleSelect/constants';
import type { InternalDropdownOption } from '~/chords/Select/components/DropdownTreeSingleSelect/types';

export function DropdownItemLabel({
  option,
  searchQuery,
}: {
  option: InternalDropdownOption;
  searchQuery?: string;
}) {
  const optionLabel = option.label || option.value;

  if (!searchQuery) {
    return optionLabel;
  }

  const searchTerms = searchQuery.toLowerCase().split(SEARCH_SPLIT_REGEX);
  const optionSplit = optionLabel.split(SEARCH_SPLIT_REGEX);
  const optionMatches = optionLabel.match(SEARCH_SPLIT_REGEX);

  return (
    <span className="text-emphasis-stronger">
      {optionSplit.map((word, index) => {
        const match = searchTerms.find(
          (term) => term && word.toLowerCase().startsWith(term),
        );

        if (match) {
          return (
            <Fragment key={index}>
              <mark className="bg-transparent text-default">
                {word.slice(0, match.length)}
              </mark>
              {word.slice(match.length)}
              {optionMatches?.[index]}
            </Fragment>
          );
        }

        return (
          <Fragment key={index}>
            {word}
            {optionMatches?.[index]}
          </Fragment>
        );
      })}
    </span>
  );
}

DropdownItemLabel.displayName = 'DropdownItemLabel';
